import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearinfoOrder, getinfoOrder } from '../../../actions/marketPlaceActions'
import { createPaymentlinkByID } from '../../../actions/PasarelaActions'
import { clearSubOrdes, getSubOrdes } from '../../../admin/actions/transferActions'
import PurchasesDetailView from '../../../containers/MarketPlace/PurchasesDetail/PurchasesDetail'
import useMercadoPago from '../../../utils/hooks/useMercadoPago'

const PurchasesDetail = ({ match }) => {
  const dispatch = useDispatch()
  const mp = useMercadoPago()
  const { pendingOrder } = useSelector(state => state.tranfers)
  const { infoOrder } = useSelector(state => state.marketPlace)




  useEffect(() => {
    dispatch(getSubOrdes(match.params.purchaseId))
    return () => {
      dispatch(clearSubOrdes())
      dispatch(clearinfoOrder())
    }
  }, [match.params.purchaseId])

  useEffect(() => {
    if (pendingOrder?.[0]) {
      dispatch(getinfoOrder(pendingOrder[0].orderId.paymentReferenceId))
    }


  }, [pendingOrder])
  const pay = (id) => {
    dispatch(createPaymentlinkByID(id,mp))
  }


  return (
    <PurchasesDetailView infoOrder={infoOrder} subOrders={pendingOrder} pay={pay} />
  )
}

export default PurchasesDetail